import React, { useEffect, useState, useRef } from "react";
import { LangOpt } from "../../utilities/languagesutils";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { showErrorNotification } from "@carrier-ecat/workflowui-globalfunctions";
import { LOCALE_SET_FULFILLED } from "../../actionTypes/actionTypes";

const LangDropdown = (props) => {
  const { changeLanguage, localeState = {}, onClose=()=>{} } = props;
  const { fullLangCode } = localeState;

  const node = useRef();

  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});

  const handleClick = (e) => {
    if (node.current.contains(e.target)) {
      return;
    }
    setOpen(false);
    onClose();
  };

  const handleChange = (selectedObj) => {
    changeLanguage({ ...selectedObj, message: localeState.message });
    setOpen(false);
    onClose();
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  useEffect(() => {
    setLang(fullLangCode);
  }, [fullLangCode]);

  function setLang(lang) {
    // window.zE("webWidget", "setLocale", lang);
    const selectedLang = LangOpt.filter((x) => x.fullLangCode === fullLangCode);

    if (selectedLang && selectedLang.length) {
      setSelectedItem(selectedLang[0]);
    }
  }

  return (
    <li ref={node} className="dropdown-lang-wrapper">
      <span
        role="button"
        className="dropdown-toggler"
        onClick={(e) => setOpen(!open)}
      >
        <img src={selectedItem?.img} alt={selectedItem?.name} />
        {selectedItem?.name}
        <span className="caret" />
      </span>
      {open && (
        <ul className="dropdown-lang dropdown-menu">
          {LangOpt.map((opt, idx) => (
            <li
              className={opt.name === selectedItem?.name ? "active" : ""}
              key={idx}
              onClick={(e) => handleChange(opt)}
            >
              <img src={opt.img} alt="" /> {opt.name}
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};
const mapStateToProps = (state) => ({
  localeState: state.locale,
});

const mapDispatchToProps = (dispatch) => {
  return {
    changeLanguage: async (data) => {
      dispatch({
        type: LOCALE_SET_FULFILLED,
        data: {
          ...data,
        },
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(LangDropdown));
